export function register() {
  // Registra se suportado pelo navegador (tanto em produção quanto desenvolvimento)
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker não suportado neste navegador');
    return;
  }

  window.addEventListener('load', async () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    try {
      // Valida existência do arquivo e MIME adequado (javascript)
      const response = await fetch(swUrl, { method: 'HEAD' });
      const contentType = response.headers.get('content-type') || '';
      if (!response.ok || !contentType.includes('javascript')) {
        console.warn('Service worker não registrado (arquivo ausente ou MIME inválido).', {
          status: response.status,
          contentType
        });
        return;
      }

      const registration = await navigator.serviceWorker.register(swUrl);
      console.log('Service worker registrado com sucesso!', registration);
      
      // Aguardar o service worker estar pronto e solicitar permissão para push
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('Novo service worker instalado e ativo');
          }
        });
      });
    } catch (error) {
      console.error('Erro durante o registro do service worker:', error);
    }
  });
}

// Função para solicitar permissão e registrar push subscription
export async function requestPushPermission() {
  if (!('Notification' in window)) {
    console.log('Este navegador não suporta notificações');
    return null;
  }

  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker não suportado');
    return null;
  }

  try {
    // Solicitar permissão
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Permissão para notificações negada');
      return null;
    }

    // Aguardar service worker estar pronto
    const registration = await navigator.serviceWorker.ready;
    
    // Verificar se push está disponível
    if (!('PushManager' in window)) {
      console.log('Push messaging não é suportado');
      return null;
    }

    // Obter subscription existente ou criar nova
    let subscription = await registration.pushManager.getSubscription();
    
    if (!subscription) {
      // Criar nova subscription
      const vapidPublicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
      if (!vapidPublicKey) {
        console.error('VAPID public key não configurada');
        return null;
      }

      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
      });
    }

    return subscription;
  } catch (error) {
    console.error('Erro ao solicitar permissão de push:', error);
    return null;
  }
}

// Função auxiliar para converter VAPID key
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
